import React from 'react'
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline'
import SelectBox from '../../../components/SelectBox'

const UserFilters = ({
  searchTerm,
  onSearchChange,
  roleFilter,
  setRoleFilter,
  roleOptions = [],
  statusFilter,
  setStatusFilter,
  statusOptions = [],
  isCompact,
}) => {
  return (
    <div className="grid gap-3 md:grid-cols-3">
      <label className="relative flex items-center rounded-2xl border border-customMuted/40 bg-white/80 px-3 py-2 text-sm shadow-sm ring-1 ring-transparent backdrop-blur dark:border-white/10 dark:bg-glassDark/80 dark:text-customWhite">
        <MagnifyingGlassIcon className="mr-2 h-5 w-5 text-customMuted" />
        <input
          type="text"
          value={searchTerm}
          onChange={event => onSearchChange(event.target.value)}
          placeholder="Search by ID or username"
          autoComplete='off'
          className="w-full bg-transparent text-customPrimaryText placeholder:text-customMuted focus:outline-none dark:text-customWhite"
        />
      </label>

      <SelectBox
        selected={roleFilter}
        setSelected={setRoleFilter}
        options={roleOptions}
        isMobile={isCompact}
        placeholder="Filter by role"
      />

      <SelectBox
        selected={statusFilter}
        setSelected={setStatusFilter}
        options={statusOptions}
        isMobile={isCompact}
        placeholder="Filter by status"
      />
    </div>
  )
}

export default UserFilters
